/* ============================================================
   OLIVER KRAUS — RIB product page
   Esencia (Dawn 2.0 architecture).

   Initialises only when [data-ok-rib-product-page] is present,
   so this file is inert on every other template and for every
   other section in the theme editor.

   The standard Add to cart deliberately does NOT roll its own
   cart logic: the button lives inside the theme's own
   <product-form> + {% form 'product' %}, so Esencia's
   product-form.js performs the add, renders the cart drawer and
   surfaces errors exactly as it does everywhere else. This file
   only drives variant state around it, plus the multi-line
   Build Your Rotation and Complete The Set adds, which have no
   native equivalent.
   ============================================================ */
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-ok-rib-product-page]';
  var instances = [];

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }
  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function isNarrow() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 900px)').matches);
  }

  /* ---------- money ----------
     Mirrors the theme's money_format so the rotation preview matches
     what Shopify will charge. Cart and checkout totals themselves are
     always Shopify's, never computed here. */
  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, format); } catch (e) {}
    }
    var fmt = format || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function thousands(number, precision, thousand, decimal) {
      precision = precision === undefined ? 2 : precision;
      thousand = thousand === undefined ? ',' : thousand;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number === null) return '0';
      var fixed = (number / 100.0).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousand);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }

    var match = fmt.match(placeholder);
    var value;
    switch (match && match[1]) {
      case 'amount_no_decimals': value = thousands(cents, 0); break;
      case 'amount_with_comma_separator': value = thousands(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = thousands(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = thousands(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = thousands(cents, 0, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = thousands(cents, 2, ' ', '.'); break;
      default: value = thousands(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  /* ---------- cart, for the multi-line rotation add only ---------- */

  var Cart = {
    host: function () {
      return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    },

    sectionIds: function () {
      var host = this.host();
      if (!host || typeof host.getSectionsToRender !== 'function') return [];
      try { return host.getSectionsToRender().map(function (s) { return s.id; }); }
      catch (e) { return []; }
    },

    add: function (items) {
      var ids = this.sectionIds();
      var body = { items: items };
      if (ids.length) {
        body.sections = ids;
        body.sections_url = window.location.pathname;
      }
      return fetch(routeRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) {
            var err = new Error(data.description || data.message || 'Could not add to cart.');
            err.data = data;
            throw err;
          }
          return data;
        });
      });
    },

    /* Hand the response to the theme's own drawer, the same way
       Esencia's product-form.js does. */
    reveal: function (response) {
      var host = this.host();
      if (host && typeof host.renderContents === 'function') {
        try {
          host.renderContents(response);
          if (host.tagName === 'CART-DRAWER' && typeof host.open === 'function') host.open();
          return true;
        } catch (e) { /* fall through */ }
      }
      // No drawer in this theme context — bounce to the cart page.
      window.location.href = routeRoot() + 'cart';
      return false;
    },

    notify: function () {
      if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        try {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'ok-rib-product-page'
          });
        } catch (e) {}
      }
    }
  };

  /* ---------- focus handling ---------- */

  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';

  function focusables(root) {
    return $$(FOCUSABLE, root).filter(function (el) {
      return el.offsetWidth || el.offsetHeight || el.getClientRects().length;
    });
  }

  function trapFocus(e, root) {
    var f = focusables(root);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ============================================================
     controller
     ============================================================ */

  function PDP(root) {
    this.root = root;
    var dataEl = $('[data-ok-rp-data]', root);
    if (!dataEl) return;
    try { this.data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    this.moneyFormat = this.data.moneyFormat || '${{amount}}';
    this.strings = this.data.strings || {};
    this.selected = null;
    this.adding = false;
    this.rotationBusy = false;
    this.scrollY = 0;
    this.lastFocus = null;
    this.lightboxIndex = -1;
    this.rotation = { count: 1, cuts: ['primary', 'primary', 'primary'] };
    this.set = { choice: 'set', bra: '', thong: '' };
    this.setBusy = false;

    this.cache();
    this.bindSizes();
    this.bindProductForm();
    this.bindAccordions();
    this.bindTracks();
    this.bindLightbox();
    this.bindSizeGuide();
    this.bindWorn();
    this.bindRotation();
    this.bindSet();
    this.bindStickyBar();
    this.bindReveals();
    this.bindKeys();
    this.bindCartEvents();

    this.restoreVariant();
  }

  PDP.prototype.cache = function () {
    var r = this.root;
    this.el = {
      productForm: $('[data-ok-rp-product-form]', r),
      form: $('form[data-type="add-to-cart-form"]', r),
      variantInput: $('[data-ok-rp-variant-input]', r),
      submit: $('[data-ok-rp-submit]', r),
      submitLabel: $('[data-ok-rp-submit-label]', r),

      sizeWrap: $('[data-ok-rp-sizes]', r),
      sizeButtons: $$('[data-ok-rp-size]', r),
      sizeError: $('[data-ok-rp-size-error]', r),

      priceNow: $('[data-ok-rp-price-now]', r),
      priceWas: $('[data-ok-rp-price-was]', r),
      live: $('[data-ok-rp-live]', r),
      buyWrap: $('[data-ok-rp-buy]', r),

      gallery: $('[data-ok-rp-gallery]', r),
      shots: $$('[data-ok-rp-shot]', r),
      galleryCounter: $('[data-ok-rp-gallery-counter]', r),
      studyTrack: $('[data-ok-rp-study-track]', r),
      studyCounter: $('[data-ok-rp-study-counter]', r),
      studyCards: $$('[data-ok-rp-study-card]', r),

      lightbox: $('[data-ok-rp-lightbox]', r),
      lightboxImg: $('[data-ok-rp-lightbox-img]', r),
      lightboxCounter: $('[data-ok-rp-lightbox-counter]', r),

      guide: $('[data-ok-rp-guide]', r),
      guideOpen: $('[data-ok-rp-guide-open]', r),

      wornPlay: $('[data-ok-rp-worn-play]', r),
      wornVideo: $('[data-ok-rp-worn-video]', r),
      wornClose: $('[data-ok-rp-worn-close]', r),

      rotationRoot: $('[data-ok-rp-rotation]', r),
      counts: $$('[data-ok-rp-count]', r),
      mix: $('[data-ok-rp-mix]', r),
      pairs: $$('[data-ok-rp-pair]', r),
      rotationTotal: $('[data-ok-rp-rotation-total]', r),
      rotationCta: $('[data-ok-rp-rotation-cta]', r),
      rotationStatus: $('[data-ok-rp-rotation-status]', r),

      setRoot: $('[data-ok-rp-set]', r),
      setChoices: $$('[data-ok-rp-set-choice]', r),
      setSizes: $$('[data-ok-rp-set-size]', r),
      setRows: {
        bra: $('[data-ok-rp-set-row="bra"]', r),
        thong: $('[data-ok-rp-set-row="thong"]', r)
      },
      setErrors: {
        bra: $('[data-ok-rp-set-error="bra"]', r),
        thong: $('[data-ok-rp-set-error="thong"]', r)
      },
      setTotal: $('[data-ok-rp-set-total]', r),
      setCta: $('[data-ok-rp-set-cta]', r),
      setStatus: $('[data-ok-rp-set-status]', r),

      sticky: $('[data-ok-rp-sticky]', r),
      stickyPrice: $('[data-ok-rp-sticky-price]', r),
      stickySize: $('[data-ok-rp-sticky-size]', r),
      stickyCta: $('[data-ok-rp-sticky-cta]', r)
    };
  };

  /* ---------- variants ---------- */

  PDP.prototype.variantFor = function (which, size) {
    var list = (this.data[which] && this.data[which].variants) || [];
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].option) === String(size)) return list[i];
    }
    return null;
  };

  PDP.prototype.restoreVariant = function () {
    var found = null;
    try {
      var id = new URLSearchParams(window.location.search).get('variant');
      if (id) {
        (this.data.main.variants || []).forEach(function (v) {
          if (String(v.id) === String(id)) found = v;
        });
      }
    } catch (e) {}

    if (found) this.pick(found.option, { silent: true, push: false });
    else { this.render(); this.renderRotation(); this.renderSet(); }
  };

  PDP.prototype.bindSizes = function () {
    var self = this;
    this.el.sizeButtons.forEach(function (btn) {
      on(btn, 'click', function () {
        if (btn.disabled) return;
        self.pick(btn.getAttribute('data-ok-rp-size'));
      });
    });
  };

  PDP.prototype.pick = function (size, opts) {
    opts = opts || {};
    this.selected = this.variantFor('main', size);

    this.el.sizeButtons.forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-ok-rp-size') === size ? 'true' : 'false');
    });
    if (this.el.sizeError) this.el.sizeError.hidden = true;

    if (this.selected) {
      if (this.el.variantInput) this.el.variantInput.value = this.selected.id;
      if (opts.push !== false) this.pushUrl(this.selected.id);
      this.showVariantMedia(this.selected);
    }

    this.render();
    this.renderRotation();
    if (!opts.silent) this.announce();
  };

  PDP.prototype.pushUrl = function (id) {
    if (!window.history || !window.history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
  };

  PDP.prototype.showVariantMedia = function (variant) {
    if (!variant || !variant.mediaId || !this.el.gallery) return;
    var target = $('[data-ok-rp-media-id="' + variant.mediaId + '"]', this.root);
    if (!target) return;
    if (isNarrow() && this.el.gallery.scrollTo) {
      this.el.gallery.scrollTo({
        left: target.offsetLeft - this.el.gallery.offsetLeft,
        behavior: reduceMotion() ? 'auto' : 'smooth'
      });
    }
  };

  PDP.prototype.announce = function (msg) {
    if (!this.el.live) return;
    if (msg) { this.el.live.textContent = msg; return; }
    var v = this.selected;
    if (!v) this.el.live.textContent = this.strings.selectSize || 'Select a size';
    else if (!v.available) this.el.live.textContent = (this.strings.soldOut || 'Sold out') + ' — ' + v.option;
    else this.el.live.textContent = v.option + ', ' + formatMoney(v.price, this.moneyFormat);
  };

  PDP.prototype.render = function () {
    var v = this.selected;
    var el = this.el;
    var price = v ? v.price : this.data.main.price;
    var compare = v ? v.compareAtPrice : this.data.main.compareAtPrice;

    if (el.priceNow) el.priceNow.textContent = formatMoney(price, this.moneyFormat);
    if (el.priceWas) {
      var show = !!(compare && compare > price);
      el.priceWas.hidden = !show;
      if (show) el.priceWas.textContent = formatMoney(compare, this.moneyFormat);
    }
    if (el.stickyPrice) el.stickyPrice.textContent = formatMoney(price, this.moneyFormat);
    if (el.stickySize) el.stickySize.textContent = v ? v.option : (this.strings.selectSize || 'Select size');

    var soldOut = !!(v && !v.available);
    var state, label;
    if (soldOut) { state = 'soldout'; label = this.strings.soldOut || 'Sold out'; }
    else if (this.adding) { state = 'loading'; label = this.strings.adding || 'Adding'; }
    else { state = 'idle'; label = this.strings.addToCart || 'Add to cart'; }

    if (el.submitLabel) el.submitLabel.textContent = label;
    if (el.submit) {
      el.submit.setAttribute('data-state', state);
      el.submit.disabled = soldOut || this.adding;
    }
    if (el.stickyCta) {
      el.stickyCta.textContent = label;
      el.stickyCta.disabled = soldOut || this.adding;
    }
    if (el.buyWrap) el.buyWrap.setAttribute('data-sold-out', soldOut ? 'true' : 'false');
  };

  /* ---------- the theme's product form ---------- */

  PDP.prototype.needSize = function () {
    if (this.selected) return true;
    if (this.el.sizeError) this.el.sizeError.hidden = false;
    if (this.el.sizeWrap) {
      var y = this.el.sizeWrap.getBoundingClientRect().top + window.scrollY - 130;
      window.scrollTo({ top: y, behavior: reduceMotion() ? 'auto' : 'smooth' });
      var first = $('[data-ok-rp-size]:not([disabled])', this.el.sizeWrap);
      if (first) first.focus();
    }
    this.announce(this.strings.selectSize || 'Select a size');
    return false;
  };

  PDP.prototype.bindProductForm = function () {
    var self = this;
    if (!this.el.productForm) return;

    /* Capture phase on the wrapper runs before the theme's own submit
       handler on the form, so an unsized submit never reaches it. */
    this.el.productForm.addEventListener('submit', function (e) {
      if (self.needSize()) {
        self.adding = true;
        self.render();
        return;
      }
      e.preventDefault();
      e.stopPropagation();
    }, true);
  };

  PDP.prototype.bindCartEvents = function () {
    var self = this;

    /* Cart host compatibility, scoped to this template.
       Some themes render the cart drawer markup without loading its script
       and styles. In that case give the element a minimal contract so the
       theme's own add-to-cart degrades to the cart page rather than
       throwing. When the drawer is fully loaded, keep only the sections it
       asks to re-render that actually exist on this page. */
    var host = Cart.host();
    if (host && !host.okRpPatched) {
      host.okRpPatched = true;
      if (typeof host.renderContents !== 'function') {
        host.getSectionsToRender = function () { return []; };
        host.setActiveElement = function () {};
        host.renderContents = function () { window.location.href = routeRoot() + 'cart'; };
      } else if (typeof host.getSectionsToRender === 'function') {
        var origSections = host.getSectionsToRender.bind(host);
        host.getSectionsToRender = function () {
          return origSections().filter(function (sec) {
            return sec.selector ? document.querySelector(sec.selector) : document.getElementById(sec.id);
          });
        };
      }
    }
    /* The drawer keeps whatever is-empty state it was rendered with. Once its
       contents have been re-rendered with real lines, clear that class so the
       theme's own focus trap targets the populated panel and not the empty
       state node it just replaced. */
    if (host && host.tagName === 'CART-DRAWER' && typeof host.renderContents === 'function' && !host.okRpEmptyPatched) {
      host.okRpEmptyPatched = true;
      var origRender = host.renderContents.bind(host);
      host.renderContents = function (state) {
        origRender(state);
        if (!host.querySelector('.drawer__inner-empty')) host.classList.remove('is-empty');
      };
    }

    this.cartSub = null;
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      try {
        this.cartSub = window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
          self.adding = false;
          self.render();
        });
      } catch (e) {}
    }
    // Safety net for themes/paths that do not publish the event.
    this.watchdog = setInterval(function () {
      if (!self.adding) return;
      self._addTicks = (self._addTicks || 0) + 1;
      if (self._addTicks > 12) { self.adding = false; self._addTicks = 0; self.render(); }
    }, 500);
  };

  /* ---------- accordions ---------- */

  PDP.prototype.bindAccordions = function () {
    var self = this;
    $$('[data-ok-rp-acc-btn]', this.root).forEach(function (btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      on(btn, 'click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) panel.hidden = open;
      });
    });

    $$('[data-ok-rp-jump]', this.root).forEach(function (link) {
      on(link, 'click', function (e) {
        var target = document.getElementById(link.getAttribute('data-ok-rp-jump'));
        if (!target) return;
        e.preventDefault();
        var btn = $('[data-ok-rp-acc-btn]', target);
        if (btn && btn.getAttribute('aria-expanded') !== 'true') btn.click();
        target.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' });
        if (btn) btn.focus();
      });
    });
  };

  /* ---------- swipe counters ---------- */

  PDP.prototype.bindTracks = function () {
    function wire(track, out, total, unitRatio, pad) {
      if (!track || !out || !total) return;
      var tick = function () {
        if (!isNarrow()) return;
        var unit = Math.max(1, track.clientWidth * unitRatio);
        var i = Math.min(total - 1, Math.max(0, Math.round(track.scrollLeft / unit)));
        var n = i + 1;
        out.textContent = pad
          ? (n < 10 ? '0' + n : n) + ' / ' + (total < 10 ? '0' + total : total)
          : n + ' / ' + total;
      };
      on(track, 'scroll', tick, { passive: true });
      on(window, 'resize', tick, { passive: true });
      tick();
    }
    wire(this.el.gallery, this.el.galleryCounter, this.el.shots.length, 1, false);
    wire(this.el.studyTrack, this.el.studyCounter, this.el.studyCards.length, 0.86, true);
  };

  /* ---------- lightbox ---------- */

  PDP.prototype.bindLightbox = function () {
    var self = this;
    if (!this.el.lightbox) return;
    this.el.shots.forEach(function (shot, i) {
      on(shot, 'click', function () { self.openLightbox(i); });
    });
    $$('[data-ok-rp-lightbox-close]', this.el.lightbox).forEach(function (b) {
      on(b, 'click', function () { self.closeLightbox(); });
    });
    on($('[data-ok-rp-lightbox-prev]', this.el.lightbox), 'click', function () { self.stepLightbox(-1); });
    on($('[data-ok-rp-lightbox-next]', this.el.lightbox), 'click', function () { self.stepLightbox(1); });
  };

  PDP.prototype.openLightbox = function (i) {
    var shot = this.el.shots[i];
    if (!shot) return;
    var img = $('img', shot);
    if (!img) return;

    if (this.lightboxIndex < 0) this.lastFocus = document.activeElement;
    this.lightboxIndex = i;

    this.el.lightboxImg.setAttribute('src', shot.getAttribute('data-ok-rp-full') || img.currentSrc || img.src);
    this.el.lightboxImg.setAttribute('alt', img.getAttribute('alt') || '');
    if (this.el.lightboxCounter) {
      this.el.lightboxCounter.textContent = (i + 1) + ' / ' + this.el.shots.length;
    }

    if (this.el.lightbox.hidden) {
      this.el.lightbox.hidden = false;
      this.lock(true);
      var f = focusables(this.el.lightbox);
      if (f.length) f[0].focus();
      if (this.el.sticky) this.el.sticky.hidden = true;
    }
  };

  PDP.prototype.stepLightbox = function (d) {
    var n = this.el.shots.length;
    if (!n) return;
    this.openLightbox((this.lightboxIndex + d + n) % n);
  };

  PDP.prototype.closeLightbox = function () {
    if (!this.el.lightbox || this.el.lightbox.hidden) return;
    this.el.lightbox.hidden = true;
    var back = this.el.shots[this.lightboxIndex] || this.lastFocus;
    this.lightboxIndex = -1;
    this.lock(false);
    if (back && back.focus) back.focus();
  };

  /* ---------- size guide ---------- */

  PDP.prototype.bindSizeGuide = function () {
    var self = this;
    if (!this.el.guide || !this.el.guideOpen) return;

    on(this.el.guideOpen, 'click', function () {
      self.lastFocus = document.activeElement;
      self.el.guide.hidden = false;
      self.lock(true);
      var f = focusables(self.el.guide);
      if (f.length) f[0].focus();
      if (self.el.sticky) self.el.sticky.hidden = true;
    });

    $$('[data-ok-rp-guide-close]', this.el.guide).forEach(function (b) {
      on(b, 'click', function () { self.closeGuide(); });
    });

    $$('[data-ok-rp-unit]', this.el.guide).forEach(function (btn) {
      on(btn, 'click', function () {
        var unit = btn.getAttribute('data-ok-rp-unit');
        $$('[data-ok-rp-unit]', self.el.guide).forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        $$('[data-ok-rp-unit-table]', self.el.guide).forEach(function (t) {
          t.hidden = t.getAttribute('data-ok-rp-unit-table') !== unit;
        });
      });
    });
  };

  PDP.prototype.closeGuide = function () {
    if (!this.el.guide || this.el.guide.hidden) return;
    this.el.guide.hidden = true;
    this.lock(false);
    if (this.el.guideOpen) this.el.guideOpen.focus();
  };

  /* ---------- worn video ---------- */

  PDP.prototype.bindWorn = function () {
    var play = this.el.wornPlay, video = this.el.wornVideo, close = this.el.wornClose;
    if (!play || !video) return;

    on(play, 'click', function () {
      var src = video.getAttribute('data-ok-rp-src');
      if (src && !video.getAttribute('src')) video.setAttribute('src', src);
      video.muted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      play.hidden = true;
      video.hidden = false;
      if (close) close.hidden = false;
      var p = video.play();
      if (p && p.catch) p.catch(function () { /* controls are visible; user can start it */ });
      if (close) close.focus();
    });

    if (close) {
      on(close, 'click', function () {
        try { video.pause(); } catch (e) {}
        video.hidden = true;
        close.hidden = true;
        play.hidden = false;
        play.focus();
      });
    }
  };

  /* ---------- build your rotation ---------- */

  PDP.prototype.bindRotation = function () {
    var self = this;
    if (!this.el.rotationRoot) return;

    this.el.counts.forEach(function (btn) {
      on(btn, 'click', function () {
        self.rotation.count = parseInt(btn.getAttribute('data-ok-rp-count'), 10) || 1;
        self.renderRotation();
      });
    });

    this.el.pairs.forEach(function (pair, idx) {
      $$('[data-ok-rp-cut]', pair).forEach(function (btn) {
        on(btn, 'click', function () {
          if (btn.disabled) return;
          self.rotation.cuts[idx] = btn.getAttribute('data-ok-rp-cut');
          self.renderRotation();
        });
      });
    });

    on(this.el.rotationCta, 'click', function () { self.addRotation(); });
  };

  PDP.prototype.unitPrice = function (cut) {
    var which = cut === 'second' ? 'boxer' : 'main';
    var size = this.selected ? this.selected.option : null;
    var v = size ? this.variantFor(which, size) : null;
    if (v) return v.price;
    return (this.data[which] && this.data[which].price) || 0;
  };

  PDP.prototype.total = function (n) {
    var t = 0;
    for (var i = 0; i < n; i++) t += this.unitPrice(this.rotation.cuts[i]);
    return t;
  };

  PDP.prototype.lines = function () {
    var size = this.selected ? this.selected.option : null;
    if (!size) return [];
    var map = {}, order = [];
    for (var i = 0; i < this.rotation.count; i++) {
      var which = this.rotation.cuts[i] === 'second' ? 'boxer' : 'main';
      var v = this.variantFor(which, size);
      if (!v || !v.available) return [];
      if (!map[v.id]) { map[v.id] = { id: v.id, quantity: 0 }; order.push(map[v.id]); }
      map[v.id].quantity += 1;
    }
    return order;
  };

  PDP.prototype.renderRotation = function () {
    if (!this.el.rotationRoot) return;
    var self = this;
    var size = this.selected ? this.selected.option : null;

    this.el.counts.forEach(function (btn) {
      var n = parseInt(btn.getAttribute('data-ok-rp-count'), 10);
      btn.setAttribute('aria-pressed', n === self.rotation.count ? 'true' : 'false');
      var p = $('[data-ok-rp-count-price]', btn);
      if (p) p.textContent = formatMoney(self.total(n), self.moneyFormat);
    });

    if (this.el.mix) this.el.mix.hidden = this.rotation.count < 2;

    this.el.pairs.forEach(function (pair, idx) {
      pair.hidden = idx >= self.rotation.count;

      var buttons = $$('[data-ok-rp-cut]', pair);
      buttons.forEach(function (btn) {
        var cut = btn.getAttribute('data-ok-rp-cut');
        var which = cut === 'second' ? 'boxer' : 'main';
        var v = size ? self.variantFor(which, size) : null;
        var out = !!(size && (!v || !v.available));
        btn.disabled = out;
        var note = $('[data-ok-rp-cut-note]', btn);
        if (note) note.textContent = out ? ' — ' + (self.strings.sizeUnavailable || 'unavailable') : '';
      });

      var current = $('[data-ok-rp-cut="' + self.rotation.cuts[idx] + '"]', pair);
      if (current && current.disabled) {
        var alt = buttons.filter(function (b) { return !b.disabled; })[0];
        if (alt) self.rotation.cuts[idx] = alt.getAttribute('data-ok-rp-cut');
      }
      buttons.forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-ok-rp-cut') === self.rotation.cuts[idx] ? 'true' : 'false');
      });
    });

    if (this.el.rotationTotal) {
      this.el.rotationTotal.textContent = formatMoney(this.total(this.rotation.count), this.moneyFormat);
    }
    if (this.el.rotationCta) {
      var label = this.rotation.count === 1
        ? (this.strings.addOne || 'Add one pair')
        : (this.strings.addN || 'Add [count] pairs').replace('[count]', this.rotation.count);
      this.el.rotationCta.textContent = this.rotationBusy ? (this.strings.adding || 'Adding') : label;
      this.el.rotationCta.disabled = this.rotationBusy || (!!size && !this.lines().length);
    }
  };

  PDP.prototype.addRotation = function () {
    var self = this;
    if (this.rotationBusy) return;
    if (!this.needSize()) {
      /* needSize() reveals the size error and moves focus; say it here too so
         the rotation module itself never fails silently. */
      this.status(this.strings.selectSize || 'Select a size first.');
      return;
    }

    var lines = this.lines();
    if (!lines.length) {
      this.status(this.strings.sizeUnavailable || 'That size is unavailable in one of the selected cuts.');
      return;
    }

    this.rotationBusy = true;
    this.status('');
    this.renderRotation();

    Cart.add(lines)
      .then(function (response) {
        self.rotationBusy = false;
        self.renderRotation();
        self.status(self.strings.rotationAdded || 'Added to your bag.');
        Cart.notify();
        Cart.reveal(response);
      })
      .catch(function (err) {
        self.rotationBusy = false;
        self.renderRotation();
        self.status(err.message || self.strings.error || 'Something went wrong. Please try again.');
      });
  };

  PDP.prototype.status = function (msg) {
    if (this.el.rotationStatus) this.el.rotationStatus.textContent = msg || '';
  };

  /* ---------- complete the set ----------
     Two independent size selectors, three purchase choices. Every line is a
     real Shopify variant resolved from live variant data; totals are the sum
     of Shopify's own prices and the cart is added through the same Ajax
     endpoint the rest of the theme uses. Nothing is discounted here. */

  PDP.prototype.setOther = function (role) {
    return role === 'bra' ? 'thong' : 'bra';
  };

  /* Which product ("main" or "matching") plays a given role on this page. */
  PDP.prototype.setSource = function (role) {
    return role === (this.data.setRole || 'bra') ? 'main' : 'matching';
  };

  PDP.prototype.setSizeOf = function (role) {
    return role === 'bra' ? this.set.bra : this.set.thong;
  };

  /* Which roles the current choice needs. */
  PDP.prototype.setNeeds = function () {
    var mine = this.data.setRole || 'bra';
    var other = this.setOther(mine);
    if (this.set.choice === 'primary') return [mine];
    if (this.set.choice === 'match') return [other];
    return mine === 'bra' ? ['bra', 'thong'] : ['thong', 'bra'];
  };

  PDP.prototype.setUnit = function (role) {
    var which = this.setSource(role);
    var size = this.setSizeOf(role);
    var v = size ? this.variantFor(which, size) : null;
    if (v) return v.price;
    return (this.data[which] && this.data[which].price) || 0;
  };

  PDP.prototype.setSum = function (choice) {
    var self = this;
    var mine = this.data.setRole || 'bra';
    var roles = choice === 'primary' ? [mine]
      : choice === 'match' ? [this.setOther(mine)]
      : ['bra', 'thong'];
    var t = 0;
    roles.forEach(function (role) { t += self.setUnit(role); });
    return t;
  };

  /* Real cart lines, or null when a needed size is missing or unavailable. */
  PDP.prototype.setLines = function () {
    var needs = this.setNeeds();
    var map = {}, order = [];
    for (var i = 0; i < needs.length; i++) {
      var role = needs[i];
      var size = this.setSizeOf(role);
      if (!size) return null;
      var v = this.variantFor(this.setSource(role), size);
      if (!v || !v.available) return null;
      if (!map[v.id]) { map[v.id] = { id: v.id, quantity: 0 }; order.push(map[v.id]); }
      map[v.id].quantity += 1;
    }
    return order;
  };

  PDP.prototype.bindSet = function () {
    var self = this;
    if (!this.el.setRoot) return;

    this.el.setChoices.forEach(function (btn) {
      on(btn, 'click', function () {
        self.set.choice = btn.getAttribute('data-ok-rp-set-choice') || 'set';
        self.setStatus('');
        self.renderSet();
      });
    });

    this.el.setSizes.forEach(function (btn) {
      on(btn, 'click', function () {
        if (btn.disabled) return;
        var role = btn.getAttribute('data-ok-rp-set-role');
        var size = btn.getAttribute('data-ok-rp-set-size');
        if (role === 'bra') self.set.bra = size; else self.set.thong = size;
        if (self.el.setErrors[role]) self.el.setErrors[role].hidden = true;
        self.setStatus('');
        self.renderSet();
      });
    });

    on(this.el.setCta, 'click', function () { self.addSet(); });
  };

  PDP.prototype.renderSet = function () {
    if (!this.el.setRoot) return;
    var self = this;
    var needs = this.setNeeds();

    this.el.setChoices.forEach(function (btn) {
      var key = btn.getAttribute('data-ok-rp-set-choice');
      btn.setAttribute('aria-pressed', key === self.set.choice ? 'true' : 'false');
      var p = $('[data-ok-rp-set-choice-price]', btn);
      if (p) p.textContent = formatMoney(self.setSum(key), self.moneyFormat);
    });

    /* Only the size selectors this choice actually needs stay in play. */
    ['bra', 'thong'].forEach(function (role) {
      var needed = needs.indexOf(role) > -1;
      var row = self.el.setRows[role];
      if (row) row.hidden = !needed;
      if (!needed && self.el.setErrors[role]) self.el.setErrors[role].hidden = true;
    });

    this.el.setSizes.forEach(function (btn) {
      var role = btn.getAttribute('data-ok-rp-set-role');
      var size = btn.getAttribute('data-ok-rp-set-size');
      var v = self.variantFor(self.setSource(role), size);
      btn.disabled = !v || !v.available;
      btn.setAttribute('aria-pressed', self.setSizeOf(role) === size ? 'true' : 'false');
    });

    var lines = this.setLines();

    if (this.el.setTotal) {
      this.el.setTotal.textContent = formatMoney(this.setSum(this.set.choice), this.moneyFormat);
    }
    if (this.el.setCta) {
      var label = this.set.choice === 'set'
        ? (this.strings.addSet || 'Add set')
        : (this.strings.addToCart || 'Add to cart');
      this.el.setCta.textContent = this.setBusy ? (this.strings.adding || 'Adding') : label;
      this.el.setCta.disabled = this.setBusy;
    }
    /* A chosen-but-unavailable combination is reported, never silently added. */
    if (!this.setBusy && lines === null) {
      var blocked = false;
      needs.forEach(function (role) {
        var size = self.setSizeOf(role);
        if (!size) return;
        var v = self.variantFor(self.setSource(role), size);
        if (!v || !v.available) blocked = true;
      });
      if (blocked) this.setStatus(this.strings.sizeUnavailable || 'That size is unavailable.');
    }
  };

  PDP.prototype.addSet = function () {
    var self = this;
    if (this.setBusy) return;

    var needs = this.setNeeds();
    var missing = null;
    for (var i = 0; i < needs.length; i++) {
      if (!this.setSizeOf(needs[i])) { missing = needs[i]; break; }
    }
    if (missing) {
      needs.forEach(function (role) {
        var err = self.el.setErrors[role];
        if (err) err.hidden = !!self.setSizeOf(role);
      });
      var focus = this.el.setRows[missing];
      if (focus) {
        focus.scrollIntoView({ block: 'center', behavior: reduceMotion() ? 'auto' : 'smooth' });
        var first = $('[data-ok-rp-set-size]:not([disabled])', focus);
        if (first) first.focus({ preventScroll: true });
      }
      return;
    }

    var lines = this.setLines();
    if (!lines || !lines.length) {
      this.setStatus(this.strings.sizeUnavailable || 'That size is unavailable.');
      return;
    }

    this.setBusy = true;
    this.setStatus('');
    this.renderSet();

    Cart.add(lines)
      .then(function (response) {
        self.setBusy = false;
        self.renderSet();
        self.setStatus(self.strings.setAdded || self.strings.rotationAdded || 'Added to your bag.');
        Cart.notify();
        Cart.reveal(response);
      })
      .catch(function (err) {
        self.setBusy = false;
        self.renderSet();
        self.setStatus(err.message || self.strings.error || 'Something went wrong. Please try again.');
      });
  };

  PDP.prototype.setStatus = function (msg) {
    if (this.el.setStatus) this.el.setStatus.textContent = msg || '';
  };

  /* ---------- sticky bar ---------- */

  PDP.prototype.bindStickyBar = function () {
    var self = this;
    var el = this.el;
    if (!el.sticky) return;

    if (el.stickyCta) {
      on(el.stickyCta, 'click', function (e) {
        if (!self.needSize()) { e.preventDefault(); return; }
        // otherwise the button's form= attribute submits the theme's product form
      });
    }

    if (el.buyWrap) {
      var okSync = function () {
        var rct = el.buyWrap.getBoundingClientRect();
        el.sticky.hidden = !(rct.bottom <= 0) || self.overlayOpen();
      };
      this.stickySync = function () {
        if (self.stickyRaf) return;
        self.stickyRaf = requestAnimationFrame(function () { self.stickyRaf = 0; okSync(); });
      };
      window.addEventListener('scroll', this.stickySync, { passive: true });
      window.addEventListener('resize', this.stickySync, { passive: true });
      okSync();
    }

    if (el.buyWrap && 'IntersectionObserver' in window) {
      this.stickyIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          el.sticky.hidden = !past || self.overlayOpen();
        });
      }, { threshold: 0 });
      this.stickyIo.observe(el.buyWrap);
    }
  };

  PDP.prototype.overlayOpen = function () {
    var el = this.el;
    return !!((el.lightbox && !el.lightbox.hidden) || (el.guide && !el.guide.hidden));
  };

  /* ---------- reveals ---------- */

  PDP.prototype.bindReveals = function () {
    var targets = $$('[data-ok-reveal]', this.root);
    if (!targets.length) return;

    if (reduceMotion() || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-shown'); });
      return;
    }

    targets.forEach(function (el) {
      var d = el.getAttribute('data-ok-reveal-delay');
      if (d) el.style.transitionDelay = d;
    });

    this.revealIo = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-shown');
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.04, rootMargin: '0px 0px -6% 0px' });

    targets.forEach(function (el) { this.revealIo.observe(el); }, this);

    this.sweepTimer = setTimeout(function () {
      targets.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-shown');
      });
    }, 1200);
  };

  /* ---------- scroll lock + keys ---------- */

  PDP.prototype.lock = function (state) {
    var b = document.body, h = document.documentElement;
    if (state) {
      this.scrollY = window.scrollY;
      b.style.position = 'fixed';
      b.style.top = -this.scrollY + 'px';
      b.style.left = '0';
      b.style.right = '0';
      b.style.width = '100%';
      h.style.overflow = 'hidden';
    } else {
      b.style.position = '';
      b.style.top = '';
      b.style.left = '';
      b.style.right = '';
      b.style.width = '';
      h.style.overflow = '';
      window.scrollTo(0, this.scrollY);
    }
  };

  PDP.prototype.bindKeys = function () {
    var self = this;
    this.keyHandler = function (e) {
      var lb = self.el.lightbox && !self.el.lightbox.hidden;
      var guide = self.el.guide && !self.el.guide.hidden;
      if (!lb && !guide) return;

      if (e.key === 'Escape') {
        e.stopPropagation();
        if (lb) return self.closeLightbox();
        return self.closeGuide();
      }
      if (lb) {
        if (e.key === 'ArrowRight') { e.preventDefault(); self.stepLightbox(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); self.stepLightbox(-1); }
      }
      if (e.key === 'Tab') trapFocus(e, lb ? self.el.lightbox : self.el.guide);
    };
    document.addEventListener('keydown', this.keyHandler, true);
  };

  PDP.prototype.destroy = function () {
    document.removeEventListener('keydown', this.keyHandler, true);
    if (this.revealIo) this.revealIo.disconnect();
    if (this.stickyIo) this.stickyIo.disconnect();
    if (this.stickySync) { window.removeEventListener('scroll', this.stickySync); window.removeEventListener('resize', this.stickySync); }
    clearTimeout(this.sweepTimer);
    clearInterval(this.watchdog);
    if (this.cartSub) { try { this.cartSub(); } catch (e) {} }
    this.lock(false);
  };

  /* ---------- boot ---------- */

  function boot() {
    $$(ROOT_SELECTOR).forEach(function (root) {
      if (root.hasAttribute('data-ok-rp-ready')) return;
      root.setAttribute('data-ok-rp-ready', 'true');
      instances.push(new PDP(root));
    });
  }

  function teardown() {
    instances.forEach(function (i) { if (i && i.destroy) i.destroy(); });
    instances = [];
    $$(ROOT_SELECTOR).forEach(function (r) { r.removeAttribute('data-ok-rp-ready'); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target || !e.target.querySelector || !e.target.querySelector(ROOT_SELECTOR)) return;
    teardown();
    boot();
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target || !e.target.querySelector || !e.target.querySelector(ROOT_SELECTOR)) return;
    teardown();
  });
})();